export const ITALIAN_PROVINCES = [
  'AGRIGENTO', 'ALESSANDRIA', 'ANCONA', 'AOSTA', 'AREZZO', 'ASCOLI PICENO', 'ASTI', 'AVELLINO',
  'BARI', 'BARLETTA-ANDRIA-TRANI', 'BELLUNO', 'BENEVENTO', 'BERGAMO', 'BIELLA', 'BOLOGNA', 'BOLZANO',
  'BRESCIA', 'BRINDISI', 'CAGLIARI', 'CALTANISSETTA', 'CAMPOBASSO', 'CARBONIA-IGLESIAS',
  'CASERTA', 'CATANIA', 'CATANZARO', 'CHIETI', 'COMO', 'COSENZA', 'CREMONA', 'CROTONE',
  'CUNEO', 'ENNA', 'FERMO', 'FERRARA', 'FIRENZE', 'FOGGIA', 'FORLI-CESENA', 'FROSINONE',
  'GENOVA', 'GORIZIA', 'GROSSETO', 'IMPERIA', 'ISERNIA', 'LA SPEZIA', 'L\'AQUILA', 'LATINA',
  'LECCE', 'LECCO', 'LIVORNO', 'LODI', 'LUCCA', 'MACERATA', 'MANTOVA', 'MASSA-CARRARA',
  'MATERA', 'MEDIO CAMPIDANO', 'MESSINA', 'MILANO', 'MODENA', 'MONZA E BRIANZA', 'NAPOLI',
  'NOVARA', 'NUORO', 'OGLIASTRA', 'OLBIA-TEMPIO', 'ORISTANO', 'PADOVA', 'PALERMO', 'PARMA',
  'PAVIA', 'PERUGIA', 'PESARO E URBINO', 'PESCARA', 'PIACENZA', 'PISA', 'PISTOIA', 'PORDENONE',
  'POTENZA', 'PRATO', 'RAGUSA', 'RAVENNA', 'REGGIO CALABRIA', 'REGGIO EMILIA', 'RIETI',
  'RIMINI', 'ROMA', 'ROVIGO', 'SALERNO', 'SASSARI', 'SAVONA', 'SIENA', 'SIRACUSA', 'SONDRIO',
  'TARANTO', 'TERAMO', 'TERNI', 'TORINO', 'TRAPANI', 'TRENTO', 'TREVISO', 'TRIESTE', 'UDINE',
  'VARESE', 'VENEZIA', 'VERBANO-CUSIO-OSSOLA', 'VERCELLI', 'VERONA', 'VIBO VALENTIA',
  'VICENZA', 'VITERBO'
] as const;

type ItalianProvince = typeof ITALIAN_PROVINCES[number];